import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { registerSW, setAppBadge, rememberSpace, spaceForPath } from "@/lib/pwa";
import { syncSubscription } from "@/lib/push";
import { useEstablishments } from "@/context/EstablishmentContext";
import { toast } from "sonner";

const FOCUS_PARAMS = ["check", "review", "competitor", "doc", "order", "policy", "anomaly", "post", "report", "briefing", "campaign", "opportunity", "composition", "supplier", "statement", "item", "keyword"];

/** Pont PWA : service worker, navigation sur clic de notification (deep link exact), bascule d'établissement (?est=), mise en évidence de l'élément ciblé (data-focus). */
export function PwaBridge() {
  const navigate = useNavigate(); const loc = useLocation();
  const { establishments, currentId, setCurrent } = useEstablishments();
  useEffect(() => { registerSW(); syncSubscription(); }, []);
  useEffect(() => { const s = spaceForPath(loc.pathname); if (s) rememberSpace(s); }, [loc.pathname]);
  useEffect(() => { const h = (e) => navigate(e.detail); window.addEventListener("respondia:navigate", h); return () => window.removeEventListener("respondia:navigate", h); }, [navigate]);
  useEffect(() => {
    const est = new URLSearchParams(loc.search).get("est");
    if (!est || est === currentId || !establishments?.length) return;
    if (establishments.some((e) => e.id === est)) setCurrent(est);
    else toast.error("Cet élément appartient à un établissement hors de votre périmètre.");
  }, [loc.search, currentId, establishments, setCurrent]);
  useEffect(() => {
    const sp = new URLSearchParams(loc.search);
    const id = FOCUS_PARAMS.map((k) => sp.get(k)).find(Boolean);
    if (!id) return;
    let tries = 0;
    const t = setInterval(() => {
      const el = document.querySelector(`[data-focus="${CSS.escape(id)}"]`);
      if (el) { clearInterval(t); el.scrollIntoView({ behavior: "smooth", block: "center" }); el.classList.add("focus-ring"); setTimeout(() => el.classList.remove("focus-ring"), 4000); }
      else if (++tries > 40) clearInterval(t);
    }, 250);
    return () => clearInterval(t);
  }, [loc.pathname, loc.search]);
  return null;
}

export function useAppBadge(count) { useEffect(() => { setAppBadge(count || 0); }, [count]); }
